export const VARIANTS = ['short', 'phone', 'long'];
